export function buildImageUrl({ src, width, quality = 75 }: { src: string; width?: number; quality?: number }) {
  if (src.startsWith('/')) {
    const params = new URLSearchParams();
    if (width != null) params.set('w', String(width));
    return params.toString() ? `${src}?${params.toString()}` : src;
  }

  const imageHost = process.env.REACT_APP_IMAGE_HOST;
  const imageUrl = new URL(src.startsWith('//') ? `https:${src}` : src);

  const params = new URLSearchParams({
    f: 'webp',
    q: quality ? String(quality) : '75'
  });

  return `${imageHost}${imageUrl.pathname}?${params.toString()}`;
}
